<script>
import Farm from '@/grazing/components/Farm.vue';

export default {
  components: {
    Farm,
  },

  props: {
    id: { type: String, required: true },
  },
}
</script>

<template>
  <api-loader
    method="get"
    :url="`v1/farms/${id}`"
    v-slot="{result: farm}">

    <farm v-if="farm" :farm="farm" />

  </api-loader>
</template>



// WEBPACK FOOTER //
// src/grazing/views/FarmView.vue